import { TrendingDown, TrendingFlat, TrendingUp } from '@mui/icons-material';
import * as React from 'react';
import colors from '../../../config/theme/colors';

export type TImagingDocumentType = SafeExtract<
  TDocumentType,
  | 'cmap'
  | 'dexa'
  | 'muscleImaging'
  | 'echocardiography'
  | 'scoliosis'
  | 'pelvis'
  | 'mri'
  | 'tt'
  | 'scintigraphy'
  | 'thymusCt'
  | 'thymusMri'
  | 'nerveUltrasound'
>;

export const docType = (
  documents: Array<IDocumentWithTypeV2<TImagingDocumentType>>,
  editing: string,
): string | undefined => documents.find(d => d._id === editing)?._type;

export const convertTrendToIcon = (
  trend: string | undefined | null,
  invertColors?: boolean,
): React.JSX.Element | null => {
  const iconStyle = {
    fontSize: '1.9rem',
    display: 'inline-block',
    backgroundColor:
      trend === 'decreased'
        ? colors[invertColors ? 'trendingNegativeBackground' : 'trendingPositiveBackground']
        : trend === 'same'
          ? colors.trendingNeutralBackground
          : trend === 'increased'
            ? colors[invertColors ? 'trendingPositiveBackground' : 'trendingNegativeBackground']
            : undefined,
    padding: '0 0.4rem 0 0.4rem',
    borderRadius: '0.5rem',
    verticalAlign: 'middle',
    marginTop: '-0.3rem',
  };

  switch (trend) {
    case 'decreased':
      return (
        <TrendingDown style={{ color: colors[invertColors ? 'trendingNegative' : 'trendingPositive'], ...iconStyle }} />
      );
    case 'same':
      return <TrendingFlat style={{ color: colors.trendingNeutral, ...iconStyle }} />;
    case 'increased':
      return (
        <TrendingUp style={{ color: colors[invertColors ? 'trendingPositive' : 'trendingNegative'], ...iconStyle }} />
      );
    default:
      return null;
  }
};
